import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Console security warning
console.log(
  '%c⚠️ FIGYELEM / WARNING! ⚠️',
  'color: #ff0000; font-size: 16px; font-weight: bold;'
);
console.log(
  '%cHa nem vagy fejlesztő, NE használd ezt a konzolt!\nIf you are not a developer, DO NOT use this console!',
  'color: #ff6b00; font-size: 12px; font-weight: bold;'
);
console.log(
  '%cRosszindulatú kód futtatása az adataid ellopásához vezethet.\nRunning malicious code here can lead to data theft.',
  'color: #ff0000; font-size: 11px;'
);
console.log(
  '%cHa valaki azt mondta, hogy másold be ide valamit, az ÁTVERÉS!\nIf someone told you to paste something here, it\'s a SCAM!',
  'color: #ff0000; font-size: 11px; font-weight: bold;'
);
console.log(
  '%c🔒 YouCRM - Secure CRM System',
  'color: #4CAF50; font-size: 10px;'
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

